<!--
Renders a hidden custom model confirm dialogue.
Usage: this.confirm('Hello World' [,okCallback [,cancelCallback]])
This component is registered and included globally in App.vue so no need to import
and declare in individual views.
this.confirm() is shorthand for this.$root.$children[0].$refs.confirm.show() and is set up in main.js.
@author bmk11u
-->
<template>
  <div>
    <div class="modal fade" id="voteConfirmModal" tabindex="-1" role="dialog" aria-labelledby="voteConfirmModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius: 20px;">
          <div class="modal-body vmrg" style="text-align:center;">
            <p style="color:#6E6F8B">{{ msg }}</p>

              <button type="button" id="voteSubmitBtn" class="list-group-item list-group-item-primary voteButton"
                data-dismiss="modal" @click="okCallback()">Yes, submit</button>
              <button type="button" id="voteCancelBtn" class="list-group-item list-group-item-primary voteButton"
                data-dismiss="modal" @click="cancelCallback()">No</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoteConfirm',
  methods: {
    // Used by container components to show the dialogue.
    // As this is a global component, if callbacks are not defined they revert to noop.
    show (msg, okCallback, cancelCallback) {
      this.msg = msg
      const backdrop = document.createElement("div");
      backdrop.classList.add("modal-backdrop", "fade", "show");
      document.body.classList.add("modal-open");
      document.body.appendChild(backdrop);
      var modal = document.getElementById('voteConfirmModal')
      modal.style.display = "block";
      modal.setAttribute("aria-hidden", "false", "show");
      modal.classList.add("show");

      if (okCallback) {
        this.okCallback = okCallback
      } else {
        this.okCallback = this.noop
      }
      if (cancelCallback) {
        console.log("callback got")
        console.log(cancelCallback)
        this.cancelCallback = cancelCallback
      } else {
        console.log("not got")
        this.cancelCallback = this.noop
      }
      

    },
    // Default callback function called when the OK button is clicked.
    // Container components can override this.
    okCallback () {
      this.noop()
    },
    // Default callback function called when the Cancel button is clicked.
    // Container components can override this.
    cancelCallback () {
      this.noop()
    },
    // No op function for default/unspecified callbacks.
    noop () {
      console.log('noop')
    }
  },
  data () {
    return {
      msg: ''
    }
  }
}
</script>
<style>

.vmrg {
  margin-right:24px;
  margin-left:24px;
}
#voteSubmitBtn {
  border: 1px solid #003865;
  background-color:#003865;
  color:#ffffff;
  font-weight:700;
  border-radius:12px;

  margin-bottom:12px;
}

#voteCancelBtn {
  border: 1px solid #003865;
  background-color:#ffffff;
  color:#003865;
  font-weight:700;
  border-radius:12px;

}

#voteConfirmModal {
  margin-top:40vh;
}
</style>
